import FundsGrid from './FundsGrid/index';
export default FundsGrid;
